import { PAGES } from '@/constants';

const Auth = () =>
    import(/* webpackChunkName: 'projects' */ '@/views/Auth.vue');

const CompetitiveKeyword = () =>
    import(
        /* webpackChunkName: 'competitiveKeyword' */ '@/views/competitiveKeyword/CompetitiveKeyword.vue'
    );
const CompetitiveKeywordTop = () =>
    import(
        /* webpackChunkName: 'competitiveKeyword' */ '@/views/competitiveKeyword/CompetitiveKeywordTop.vue'
    );
const CompetitiveKeywordSuggestAnalysis = () =>
    import(
        /* webpackChunkName: 'competitiveKeyword' */ '@/views/competitiveKeyword/CompetitiveKeywordSuggestAnalysis.vue'
    );

const CompetitiveSiteKeyword = () =>
    import(
        /* webpackChunkName: 'competitiveSiteKeyword' */ '@/views/competitiveSiteKeyword/CompetitiveSiteKeyword.vue'
    );
const CompetitiveSiteKeywordTop = () =>
    import(
        /* webpackChunkName: 'competitiveSiteKeyword' */ '@/views/competitiveSiteKeyword/CompetitiveSiteKeywordTop.vue'
    );
const CompetitiveSiteKeywordResult = () =>
    import(
        /* webpackChunkName: 'competitiveSiteKeyword' */ '@/views/competitiveSiteKeyword/CompetitiveSiteKeywordResult.vue'
    );

const Config = () =>
    import(/* webpackChunkName: 'config' */ '@/views/config/Config.vue');
const ConfigContract = () =>
    import(
        /* webpackChunkName: 'config' */ '@/views/config/ConfigContract.vue'
    );
const ConfigManagement = () =>
    import(
        /* webpackChunkName: 'config' */ '@/views/config/ConfigManagement.vue'
    );
const ConfigPayment = () =>
    import(/* webpackChunkName: 'config' */ '@/views/config/ConfigPayment.vue');
const ConfigProject = () =>
    import(/* webpackChunkName: 'config' */ '@/views/config/ConfigProject.vue');
const ConfigUser = () =>
    import(/* webpackChunkName: 'config' */ '@/views/config/ConfigUser.vue');
const ConfigUserProvisional = () =>
    import(
        /* webpackChunkName: 'config' */ '@/views/config/ConfigUserProvisional.vue'
    );
const Projects = () =>
    import(/* webpackChunkName: 'projects' */ '@/views/Projects.vue');
const Error = () => import(/* webpackChunkName: 'error' */ '@/views/Error.vue');
const ErrorAccount = () =>
    import(/* webpackChunkName: 'error' */ '@/views/ErrorAccount.vue');
const Login = () => import(/* webpackChunkName: 'login' */ '@/views/Login.vue');

const Organization = () =>
    import(/* webpackChunkName: 'organization' */ '@/views/Organization.vue');

const Payment = () =>
    import(/* webpackChunkName: 'payment' */ '@/views/payment/Payment.vue');
const PaymentCard = () =>
    import(/* webpackChunkName: 'payment' */ '@/views/payment/PaymentCard.vue');
const PaymentPlan = () =>
    import(/* webpackChunkName: 'payment' */ '@/views/payment/PaymentPlan.vue');
const PaymentSelect = () =>
    import(
        /* webpackChunkName: 'payment' */ '@/views/payment/PaymentSelect.vue'
    );

const Project = () =>
    import(/* webpackChunkName: 'project' */ '@/views/Project.vue');

const Register = () =>
    import(/* webpackChunkName: 'register' */ '@/views/register/Register.vue');
const RegisterInput = () =>
    import(
        /* webpackChunkName: 'register' */ '@/views/register/RegisterInput.vue'
    );
const RegisterConfirm = () =>
    import(
        /* webpackChunkName: 'register' */ '@/views/register/RegisterConfirm.vue'
    );
const RegisterError = () =>
    import(
        /* webpackChunkName: 'register' */ '@/views/register/RegisterError.vue'
    );
const RegisterProvisional = () =>
    import(
        /* webpackChunkName: 'register' */ '@/views/register/RegisterProvisional.vue'
    );
const RegisterRegister = () =>
    import(
        /* webpackChunkName: 'register' */ '@/views/register/RegisterRegister.vue'
    );

const ReportDownload = () =>
    import(
        /* webpackChunkName: 'reportDownload' */ '@/views/ReportDownload.vue'
    );

const ResetPassword = () =>
    import(
        /* webpackChunkName: 'resetPassword' */ '@/views/resetPassword/ResetPassword.vue'
    );
const ResetPasswordInput = () =>
    import(
        /* webpackChunkName: 'resetPassword' */ '@/views/resetPassword/ResetPasswordInput.vue'
    );
const ResetPasswordConfirm = () =>
    import(
        /* webpackChunkName: 'resetPassword' */ '@/views/resetPassword/ResetPasswordConfirm.vue'
    );

const SearchVolume = () =>
    import(/* webpackChunkName: 'searchVolume' */ '@/views/SearchVolume.vue');

const Seo = () => import(/* webpackChunkName: 'seo' */ '@/views/seo/Seo.vue');
const SeoTop = () =>
    import(/* webpackChunkName: 'seo' */ '@/views/seo/SeoTop.vue');
const SeoResult = () =>
    import(/* webpackChunkName: 'seo' */ '@/views/seo/SeoResult.vue');

const Set = () => import(/* webpackChunkName: 'set' */ '@/views/set/Set.vue');
const SetName = () =>
    import(/* webpackChunkName: 'set' */ '@/views/set/SetName.vue');
const SetErrorGA = () =>
    import(/* webpackChunkName: 'set' */ '@/views/set/SetErrorGA.vue');
const SetSelectGA = () =>
    import(/* webpackChunkName: 'set' */ '@/views/set/SetSelectGA.vue');
const SetErrorGA4 = () =>
    import(/* webpackChunkName: 'set' */ '@/views/set/SetErrorGA4.vue');
const SetSelectGA4 = () =>
    import(/* webpackChunkName: 'set' */ '@/views/set/SetSelectGA4.vue');
const SetGSC = () =>
    import(/* webpackChunkName: 'set' */ '@/views/set/SetGSC.vue');
const SetErrorGSC = () =>
    import(/* webpackChunkName: 'set' */ '@/views/set/SetErrorGSC.vue');
const SetSelectGSC = () =>
    import(/* webpackChunkName: 'set' */ '@/views/set/SetSelectGSC.vue');
const SetConfirm = () =>
    import(/* webpackChunkName: 'set' */ '@/views/set/SetConfirm.vue');

const SiteImportantKeyword = () =>
    import(
        /* webpackChunkName: 'siteImportantKeyword' */ '@/views/siteImportantKeyword/SiteImportantKeyword.vue'
    );

const ResultsCheck = () =>
    import(
        /* webpackChunkName: 'resultsCheck' */ '@/views/siteImportantKeyword/ResultsCheck.vue'
    );
const ResultsCheckActions = () =>
    import(
        /* webpackChunkName: 'resultsCheck' */ '@/views/siteImportantKeyword/ResultsCheckActions.vue'
    );
const ResultsCheckRanks = () =>
    import(
        /* webpackChunkName: 'resultsCheck' */ '@/views/siteImportantKeyword/ResultsCheckRanks.vue'
    );

const SiteKeywordAnalysis = () =>
    import(
        /* webpackChunkName: 'siteKeywordAnalysis' */ '@/views/siteKeywordAnalysis/SiteKeywordAnalysis.vue'
    );
const ContentPlans = () =>
    import(
        /* webpackChunkName: 'contentPlans' */ '@/views/contentPlans/ContentPlans.vue'
    );
const ContentPlansTop = () =>
    import(
        /* webpackChunkName: 'contentPlans' */ '@/views/contentPlans/ContentPlansTop.vue'
    );
const ContentPlansSuggest = () =>
    import(
        /* webpackChunkName: 'contentPlans' */ '@/views/contentPlans/ContentPlansSuggest.vue'
    );
const ContentPlansSurvey = () =>
    import(
        /* webpackChunkName: 'contentPlans' */ '@/views/contentPlans/ContentPlansSurvey.vue'
    );
const ContentPlansWriting = () =>
    import(
        /* webpackChunkName: 'contentPlans' */ '@/views/contentPlans/ContentPlansWriting.vue'
    );
const ContentRewrite = () =>
    import(
        /* webpackChunkName: 'contentRewrite' */ '@/views/contentRewrite/ContentRewrite.vue'
    );
const TaskList = () =>
    import(/* webpackChunkName: 'taskList' */ '@/views/taskList/TaskList.vue');
const TaskListTop = () =>
    import(
        /* webpackChunkName: 'taskList' */ '@/views/taskList/TaskListTop.vue'
    );
const TaskListProposals = () =>
    import(
        /* webpackChunkName: 'taskList' */ '@/views/taskList/TaskListProposals.vue'
    );
const SiteSummary = () =>
    import(
        /* webpackChunkName: 'siteSummary' */ '@/views/siteSummary/SiteSummary.vue'
    );
const Dashboard = () =>
    import(/* webpackChunkName: 'dashboard' */ '@/views/Dashboard.vue');

const routes = [
    {
        name: 'auth',
        path: '/auth',
        component: Auth,
        meta: {
            title: PAGES.auth.title
        }
    },
    {
        path: '/config',
        component: Config,
        redirect: { name: 'configUser' },
        meta: {
            hasHeader: true,
            hasFooter: true,
            requiresAuth: true,
            disableDemo: false
        },
        children: [
            {
                name: 'configContract',
                path: '/config/contract',
                component: ConfigContract,
                meta: {
                    requiresOrganization: true,
                    title: PAGES.config.title
                }
            },
            {
                name: 'configManagement',
                path: '/config/management',
                component: ConfigManagement,
                meta: {
                    requiresOrganization: true,
                    title: PAGES.config.title
                }
            },
            {
                name: 'configPayment',
                path: '/config/payment',
                component: ConfigPayment,
                meta: {
                    requiresOrganization: true,
                    title: PAGES.config.title,
                    disableDemo: true
                }
            },
            {
                name: 'configUser',
                path: '/config/user',
                component: ConfigUser,
                meta: {
                    title: PAGES.config.title,
                    disableDemo: true
                }
            }
        ]
    },
    {
        name: 'configUserProvisional',
        path: '/config/user/provisional',
        component: ConfigUserProvisional,
        meta: {
            hasFooter: true,
            hasSide: false,
            title: PAGES.config.provisional.title,
            disableDemo: true
        },
        props: route => ({
            email: route.query.email
        })
    },
    {
        name: 'projects',
        path: '/projects',
        component: Projects,
        meta: {
            hasHeader: true,
            hasFooter: true,
            hasSide: false,
            hasSideInfo: true,
            requiresAuth: true,
            requiresOrganization: true,
            title: PAGES.projects.title
        }
    },
    {
        name: 'login',
        path: '/',
        component: Login,
        meta: {
            hasFooter: false,
            title: PAGES.login.title
        }
    },
    {
        name: 'organization',
        path: '/organization',
        component: Organization,
        meta: {
            hasHeader: true,
            hasFooter: true,
            hasSide: false,
            hasSideInfo: true,
            requiresAuth: true,
            title: PAGES.organization.title
        }
    },
    {
        name: 'payment',
        path: '/payment',
        component: Payment,
        redirect: { name: 'paymentPlan' },
        meta: {
            hasFooter: true,
            requiresAuth: true,
            disableDemo: true
        },
        children: [
            {
                name: 'paymentPlan',
                path: '/payment/plan',
                component: PaymentPlan,
                meta: {
                    title: PAGES.payment.plan.title
                }
            },
            {
                name: 'paymentSelect',
                path: '/payment/select',
                component: PaymentSelect,
                meta: {
                    title: PAGES.payment.select.title
                }
            },
            {
                name: 'paymentCard',
                path: '/payment/card',
                component: PaymentCard,
                meta: {
                    title: PAGES.payment.card.title
                }
            }
        ]
    },
    {
        path: '/register',
        component: Register,
        redirect: { name: '404' },
        meta: {
            hasFooter: true,
            disableDemo: true
        },
        children: [
            {
                name: 'registerTrial',
                path: '/register/trial/form',
                component: RegisterInput,
                meta: {
                    title: PAGES.register.trial.title
                },
                props: route => ({
                    agentCode: route.query.agentCode
                })
            },
            {
                name: 'registerTrialConfirm',
                path: '/register/trial/confirm',
                component: RegisterConfirm,
                meta: {
                    title: PAGES.register.trial.confirm.title
                },
                props: route => ({
                    agentCode: route.query.agentCode
                })
            },
            {
                name: 'registerError',
                path: '/register/error',
                component: RegisterError,
                meta: {
                    title: PAGES.register.error.title
                }
            },
            {
                name: 'registerProvisional',
                path: '/register/provisional',
                component: RegisterProvisional,
                meta: {
                    title: PAGES.register.provisional.title
                }
            },
            {
                name: 'registerRegister',
                path: '/register/register',
                component: RegisterRegister,
                meta: {
                    title: PAGES.register.register.title
                }
            }
        ]
    },
    {
        path: '/reset-password',
        component: ResetPassword,
        meta: {
            hasFooter: true,
            disableDemo: true
        },
        children: [
            {
                name: 'resetPassword',
                path: '/reset-password',
                component: ResetPasswordInput,
                meta: {
                    title: PAGES.resetPassword.title
                },
                props: route => ({
                    email: route.query.email
                })
            },
            {
                name: 'resetPasswordConfirm',
                path: '/reset-password/confirm',
                component: ResetPasswordConfirm,
                meta: {
                    title: PAGES.resetPassword.confirm.title
                }
            }
        ]
    },
    {
        name: 'setSelectGA4',
        path: '/set/ga4/select',
        component: SetSelectGA4,
        meta: {
            hasFooter: true,
            requiresAuth: true,
            requiresOrganization: true,
            disableDemo: true,
            title: PAGES.set.select_ga.title
        }
    },
    {
        name: 'setErrorGA',
        path: '/set/ga/error',
        component: SetErrorGA,
        meta: {
            hasFooter: true,
            requiresAuth: true,
            requiresOrganization: true,
            disableDemo: true,
            title: PAGES.set.error_ga.title
        }
    },
    {
        name: 'setErrorGA4',
        path: '/set/ga4/error',
        component: SetErrorGA4,
        meta: {
            hasFooter: true,
            requiresAuth: true,
            requiresOrganization: true,
            disableDemo: true,
            title: PAGES.set.error_ga.title
        }
    },
    {
        name: 'setErrorGSC',
        path: '/set/sc/error',
        component: SetErrorGSC,
        meta: {
            hasFooter: true,
            requiresAuth: true,
            requiresOrganization: true,
            disableDemo: true,
            title: PAGES.set.error_gsc.title
        }
    },
    {
        name: 'set',
        path: '/set',
        component: Set,
        redirect: { name: 'setName' },
        meta: {
            hasFooter: true,
            requiresAuth: true,
            requiresOrganization: true,
            disableDemo: true
        },
        children: [
            {
                name: 'setName',
                path: '/set',
                component: SetName,
                meta: {
                    title: PAGES.set.title
                }
            },
            {
                name: 'setConfirm',
                path: '/set/confirm',
                component: SetConfirm,
                meta: {
                    title: PAGES.set.confirm.title
                }
            },
            {
                name: 'setGSC',
                path: '/set/sc/gsc',
                component: SetGSC,
                meta: {
                    title: PAGES.set.gsc.title
                }
            },
            {
                name: 'setSelectGA',
                path: '/set/ga/select',
                component: SetSelectGA,
                meta: {
                    title: PAGES.set.select_ga.title
                }
            },
            {
                name: 'setSelectGSC',
                path: '/set/sc/select',
                component: SetSelectGSC,
                meta: {
                    title: PAGES.set.select_gsc.title
                }
            }
        ]
    },
    {
        name: 'error',
        path: '/error',
        component: Error,
        meta: {
            hasFooter: true,
            title: PAGES.error.title
        }
    },
    {
        name: 'errorAccount',
        path: '/error/account',
        component: ErrorAccount,
        meta: {
            hasFooter: true,
            title: PAGES.errorAccount.title
        }
    },
    {
        name: 'project',
        path: '/:projectId',
        component: Project,
        meta: {
            hasHeader: true,
            hasSide: true,
            hasFooter: true,
            requiresAuth: true,
            requiresOrganization: true,
            requiresProject: true
        },
        children: [
            {
                path: '/:projectId/competitive-keyword',
                component: CompetitiveKeyword,
                meta: {
                    hasTask: true
                },
                children: [
                    {
                        name: 'competitiveKeyword',
                        path: '/:projectId/competitive-keyword',
                        component: CompetitiveKeywordTop,
                        meta: {
                            title: PAGES.competitiveKeyword.title
                        }
                    },
                    {
                        name: 'competitiveKeywordSuggestAnalysis',
                        path:
                            '/:projectId/competitive-keyword/:keywordId/suggest-analysis',
                        component: CompetitiveKeywordSuggestAnalysis,
                        meta: {
                            breadcrumbs: [
                                {
                                    name: 'competitiveKeyword',
                                    title: PAGES.competitiveKeyword.title
                                }
                            ],
                            title:
                                PAGES.competitiveKeyword.suggestAnalysis.title
                        },
                        props: route => ({
                            keyword: route.query.keyword,
                            keywordId: route.params.keywordId,
                            startDate: route.query.startDate
                        })
                    }
                ]
            },
            {
                path: '/:projectId/competitive-site-keyword',
                component: CompetitiveSiteKeyword,
                meta: {
                    hasTask: true
                },
                children: [
                    {
                        name: 'competitiveSiteKeyword',
                        path: '/:projectId/competitive-site-keyword',
                        component: CompetitiveSiteKeywordTop,
                        meta: {
                            title: PAGES.competitiveSiteKeyword.title
                        }
                    },
                    {
                        name: 'competitiveSiteKeywordResult',
                        path:
                            '/:projectId/competitive-site-keyword/:competitorSiteId',
                        component: CompetitiveSiteKeywordResult,
                        meta: {
                            breadcrumbs: [
                                {
                                    name: 'competitiveSiteKeyword',
                                    title: PAGES.competitiveSiteKeyword.title
                                }
                            ],
                            title:
                                PAGES.competitiveSiteKeyword
                                    .competitiveSiteKeywordResult.title
                        }
                    }
                ]
            },
            {
                path: '/:projectId/config',
                component: Config,
                redirect: { name: 'configProject' },
                children: [
                    {
                        name: 'configProject',
                        path: '/:projectId/config/project',
                        component: ConfigProject,
                        meta: {
                            title: PAGES.config.project.title
                        }
                    }
                ]
            },
            {
                name: 'reportDownload',
                path: '/:projectId/report-download',
                component: ReportDownload,
                meta: {
                    title: PAGES.reportDownload.title,
                    hasTask: true
                }
            },
            {
                name: 'searchVolume',
                path: '/:projectId/search-volume',
                component: SearchVolume,
                meta: {
                    title: PAGES.searchVolume.title,
                    hasTask: true
                }
            },
            {
                path: '/:projectId/seo',
                component: Seo,
                meta: {
                    hasTask: true
                },
                props: route => ({
                    date: route.query.date,
                    id: route.query.id
                }),
                children: [
                    {
                        name: 'seo',
                        path: '/:projectId/seo',
                        component: SeoTop,
                        meta: {
                            title: PAGES.seo.title
                        }
                    },
                    {
                        name: 'seoResult',
                        path: '/:projectId/seo/result',
                        component: SeoResult,
                        meta: {
                            breadcrumbs: [
                                {
                                    name: 'seo',
                                    title: PAGES.seo.title
                                }
                            ],
                            title: PAGES.seo.result.title
                        }
                    }
                ]
            },
            {
                name: 'siteImportantKeyword',
                path: '/:projectId/site-important-keyword',
                component: ResultsCheck,
                redirect: { name: 'siteImportantKeywordActions' },
                meta: {
                    title: PAGES.siteImportantKeyword.title
                },
                props: route => ({
                    id: route.query.id,
                    keyword: route.query.keyword,
                    status: route.query.status
                }),
                children: [
                    {
                        name: 'siteImportantKeywordActions',
                        path: '/:projectId/site-important-keyword/actions',
                        component: ResultsCheckActions,
                        meta: {
                            title: PAGES.siteImportantKeyword.title,
                            isChild: true
                        }
                    },
                    {
                        name: 'siteImportantKeywordRanks',
                        path: '/:projectId/site-important-keyword/ranks',
                        component: ResultsCheckRanks,
                        meta: {
                            title: PAGES.siteImportantKeyword.title,
                            isChild: true
                        }
                    }
                ]
            },
            {
                name: 'siteImportantKeyword2',
                path: '/:projectId/site-important-keyword2',
                component: SiteImportantKeyword,
                meta: {
                    title: PAGES.siteImportantKeyword.title
                },
                props: route => ({
                    id: route.query.id,
                    keyword: route.query.keyword,
                    status: route.query.status
                })
            },
            {
                name: 'siteKeywordAnalysis',
                path: '/:projectId/site-keyword-analysis',
                component: SiteKeywordAnalysis,
                meta: {
                    title: PAGES.siteKeywordAnalysis.title,
                    hasTask: true
                },
                props: route => ({
                    rankMax: route.query.rankMax
                        ? Math.ceil(Number(route.query.rankMax))
                        : undefined,
                    rankMin: route.query.rankMin
                        ? Math.ceil(Number(route.query.rankMin))
                        : undefined,
                    sort: route.query.sort,
                    order: route.query.order
                })
            },
            {
                path: '/:projectId/content-plans',
                component: ContentPlans,
                meta: {
                    hasTask: true
                },
                props: route => ({
                    createdAt: route.query.createdAt,
                    keyword: route.query.keyword
                }),
                children: [
                    {
                        name: 'contentPlans',
                        path: '/:projectId/content-plans',
                        component: ContentPlansTop,
                        meta: {
                            title: PAGES.contentPlans.title
                        }
                    },
                    {
                        name: 'contentPlansSuggest',
                        path: '/:projectId/content-plans/suggest',
                        component: ContentPlansSuggest,
                        meta: {
                            breadcrumbs: [
                                {
                                    name: 'contentPlans',
                                    title: PAGES.contentPlans.title
                                }
                            ],
                            title: PAGES.contentPlans.contentPlansSuggest.title
                        }
                    },
                    {
                        name: 'contentPlansSurvey',
                        path: '/:projectId/content-plans/survey',
                        component: ContentPlansSurvey,
                        meta: {
                            breadcrumbs: [
                                {
                                    name: 'contentPlans',
                                    title: PAGES.contentPlans.title
                                }
                            ],
                            title: PAGES.contentPlans.contentPlansSurvey.title
                        }
                    },
                    {
                        name: 'contentPlansWriting',
                        path: '/:projectId/content-plans/writing',
                        component: ContentPlansWriting,
                        meta: {
                            breadcrumbs: [
                                {
                                    name: 'contentPlans',
                                    title: PAGES.contentPlans.title
                                }
                            ],
                            title: PAGES.contentPlans.contentPlansWriting.title
                        }
                    }
                ]
            },
            {
                path: '/:projectId/task-list',
                component: TaskList,
                children: [
                    {
                        name: 'taskList',
                        path: '/:projectId/task-list',
                        component: TaskListTop,
                        meta: {
                            title: PAGES.taskList.title
                        }
                    },
                    {
                        name: 'taskListProposals',
                        path: '/:projectId/task-list/proposals',
                        component: TaskListProposals,
                        meta: {
                            title: PAGES.taskList.title
                        }
                    }
                ]
            },
            {
                name: 'siteSummary',
                path: '/:projectId/ga-gsc-data-summary',
                component: SiteSummary,
                meta: {
                    title: PAGES.siteSummary.title,
                    hasTask: true
                }
            },
            {
                name: 'dashboard',
                path: '/:projectId/dashboard',
                component: Dashboard,
                meta: {
                    title: PAGES.dashboard.title,
                    hasTask: false
                }
            },
            {
                name: 'contentRewrite',
                path: '/:projectId/content-rewrite',
                component: ContentRewrite,
                meta: {
                    title: PAGES.contentRewrite.title,
                    hasTask: true
                }
            }
        ]
    },
    {
        name: '404',
        path: '*'
    }
];

export default routes;
